import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/id/general/page';

export const Route = createFileRoute('/_app/_chat/skills/$id/general/')({
  component: Page,
});
